module.exports = __webpack_public_path__ + "img/cricket.3cf28430.svg";